import { MarketplaceView } from '@khal-os/desktop-shell';
import type { ComponentType } from 'react';
import { QaSystemBridge } from './components/QaSystemBridge';

export type BuiltinAppComponent = ComponentType<{
	windowId: string;
	meta?: Record<string, unknown>;
}>;

/**
 * Built-in components ship inside the desktop client and MUST NOT be fetched
 * from the kernel as dynamic packs. Do not put pack-backed bundled apps such as
 * `files` and `settings` here: those are real KHAL app bundles and must fall
 * through to `DynamicAppBundle` so the launcher opens the product UI, not a
 * placeholder bridge.
 */
export const BUILTIN_COMPONENTS: Record<string, BuiltinAppComponent> = {
	marketplace: () => <MarketplaceView />,
	// Eugenia QA System is registered by Nebulosa, but the pack artifact is
	// currently absent from `/apps/qa-system/bundle.mjs`. Keep the launcher entry
	// usable by routing it to the native bridge instead of the dynamic loader.
	'qa-system': QaSystemBridge,
};

export const BUILTIN_LABELS: Record<string, string> = {
	files: 'Files',
	settings: 'Settings',
	marketplace: 'App Store',
	'qa-system': 'QA System',
};

export const BUILTIN_APP_IDS = Object.freeze(Object.keys(BUILTIN_COMPONENTS));
